
<template>
  <div class="main-content" id="panel">
    <!-- Header -->
    <!-- <Header /> -->
    <!-- Header -->
    <div class="header bg-primary pb-6">
      <div class="container-fluid">
        <div class="header-body">
          <div class="row align-items-center py-4">
            <div class="col-lg-6 col-7">
              <h2>Upload</h2>
              <nav aria-label="breadcrumb" class="d-none d-md-inline-block">
                <ol class="breadcrumb breadcrumb-links breadcrumb-dark">
                  <li class="breadcrumb-item">
                      <i class="fas fa-home"></i>
                  </li>
                  <li class="breadcrumb-item">
                    Data Aggregator
                  </li>
                  <li class="breadcrumb-item">
                    Import Data
                  </li>
                </ol>
              </nav>
            </div>
            <div class="col-lg-6 col-5 text-right"></div>
          </div>
          <!-- Card stats -->
        </div>
      </div>
    </div>
    <!-- Page content -->
    <div class="container-fluid mt--6">
      <div class="row justify-content-md-center upload">
        <div class="col-xl-5">
          <div class="card">
            <div class="card-header bg-transparent">
              <div class="row align-items-center">
                <div class="col">
                  <h3>UPLOAD CSV</h3>
                </div>
              </div>
            </div>
            <div class="card-body">
              <!-- Chart -->
              <div class="chart">
                <span class="round"><img src="../../assets/img/vector/upload-csv01.png" alt /></span>
                <h4>
                  <i class="fa fa-arrow-circle-right" aria-hidden="true"></i> INFORMATION
                </h4>
                <p>Please select a CSV file for upload.From the uploaded file only three specific accounts viz. SMU-000001, SMU-000002 and BPB-000098 will be imported and rest of the data will be ignored.</p>

                <!-- <input id="file-upload" type="file" accept=".csv" /> -->

                <!-- <button id="addphoto" @click="upload('input')" class="btn btn-primary">
                  Upload
                  <i v-if="!loading" class="fa fa-arrow-circle-right" aria-hidden="true"></i>
                  <i v-if="loading" class="fa fa-spinner fa-spin" aria-hidden="true"></i>
                </button> -->
                <br />
                <br />
                <label for="file-upload" class="custom-file-upload btn btn-primary my-2">
                  UPLOAD CSV
                  <i v-if="!loading" class="fas fa-cloud-upload-alt"></i>
                  <i v-if="loading" class="fa fa-spinner fa-spin" aria-hidden="true"></i>
                </label>
                <input id="file-upload" type="file" accept=".csv"  @change="upload('input')" />
                <div v-if="error" class="alert alert-danger" role="alert">
                  <i class="fas fa-exclamation-triangle"></i>
                  File upload failed. Please try again
                </div>
                <!-- <div v-if = "error" class="alert alert-danger" role="alert">
                    Error while uploading.
                </div>-->
                <div v-if="success" class="alert alert-success" role="alert">
                  <i class="fas fa-check-circle"></i>
                  Your CSV has been successfully uploaded.<br>
                  <span v-if="cusipCount == 0 && tradeCount == 0"> No Trades imported. Check if the CSV file valid or same Trades/CUSIP have been imported already and have trades with account numbers SMU-000001, SMU-000002 and BPB-000098.</span>
                  <span v-if="cusipCount == 0 && tradeCount > 0"> {{tradeCount}} trades imported. 0 new CUSIP </span>
                  <span v-if="cusipCount > 0 && tradeCount > 0"> {{tradeCount}} trades and {{cusipCount}} new CUSIP imported. Update the state and purpose information of new CUSIP </span>
                </div>
                <!-- <div  v-if = "success" class="alert alert-success" role="alert">
                    Data has been inserted successfully
                </div>-->
                <router-link to="/traderecap/viewdata">
                  <i class="fa fa-desktop" aria-hidden="true"></i>
                  GOTO VIEW DATA
                </router-link>
                <!-- <a href="#"><i class="fa fa-desktop" aria-hidden="true"></i> GOTO DASHBOARD</a> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Footer -->
      <!-- <Footer /> -->
    </div>
  </div>
</template>

<script>
import AWS from 'aws-sdk/global';
import config from "@/config";
//import this.$http from "this.$http";
// import Header from "../common/Header";
// import Footer from "../common/Footer";

export default {
  name: "HomePage",
  components: {
    // Header,
    // Footer
  },
  data() {
    return {
      user: {},
      accessToken: null,
      error: null,
      success: null,
      loading: false,
      cusipCount: 0,
      tradeCount: 0
    };
  },
  methods: {
    upload: function(albumName) {
      this.error = false;
      this.success = false;
      var s3 = new AWS.S3({
        apiVersion: "2006-03-01",
        params: { Bucket: "trade-recap" }
      });
      console.log(s3);
      var files = document.getElementById("file-upload").files;
      if (!files.length) {
        return alert("Please choose a file to upload first.");
      }
      var file = files[0];
      var fileName = file.name;
      var albumPhotosKey = encodeURIComponent(albumName) + "/";

      var photoKey = albumPhotosKey + fileName;
      var albumBucketName = config.albumBucketName;
      console.log(photoKey);
      this.loading = true;
      // Use S3 ManagedUpload class as it supports multipart uploads
      var self = this;
      s3.upload(
        { Key: file.name, Bucket: albumBucketName, Body: file, ACL: "private" },
        function(err, data) {
          this.fileuploading = false;
          if (err) {
            console.log(err, "there was an error uploading your file");
          } else {
            this.locationUrl = data.Location;
            this.serviceBucketName = data.Bucket;
            this.s3response = data;
            const auth = {
              headers: { authorization: self.accessToken }
            };
            console.log("http",self.$http);
            self.$http
              .post(
                config.baseUrl +"/import",
                {
                  bucketName: "trade-recap",
                  fileName: "csv/" + file.name
                },
                auth
              )
              .then(response => {
                console.log("Success", response);
                self.loading = false;
                self.error = false;
                self.success = true;
                self.cusipCount = response.data.newCusipCount;
                self.tradeCount = response.data.tradeCount;
                //self.$router.push("/viewdata");
              })
              .catch(e => {
                console.log("Error", e);
                self.error = true;
                self.success = false;
                self.loading = false;
              });
          }
        }
      );
    }
  },

  created: function() {
    this.user = this.$cognitoAuth.getCurrentUser();
    this.$cognitoAuth.getIdToken((err, result) => {
      if (err) {
        console.log("accessToken is not found", err);
      } else {
        this.accessToken = result;
      }
    });
    const userPoolLoginKey = config.userPoolLoginKey;
    const logins = {};
    logins[userPoolLoginKey] = this.accessToken;
    AWS.config.region = config.region;
    const cognitoParams = {
      IdentityPoolId: config.IdentityPoolIdFileUpload,
      Logins: logins
    };
    let cognitoidentity = new AWS.CognitoIdentity();
    cognitoidentity.getId(cognitoParams, function(err, data) {
      if (err) {
        console.log(err);
      } else {
        console.log(data.IdentityId);
        let bucketRegion = AWS.config.region;
        AWS.config.update({
          region: bucketRegion,
          credentials: new AWS.CognitoIdentityCredentials(cognitoParams)
        });
      }
    });
  }
};
</script>